import Login from "../views/pages/outer_layout/Login";
import Register from "../views/pages/outer_layout/Register";
import ForgetPassword from "../views/pages/outer_layout/ForgetPassword";
import UserActivation from '../views/pages/outer_layout/UserActivation';
import ChangePassword from '../views/pages/outer_layout/ChangePassword';

export const OUTER_ROUTES = {
  LOGIN: "/login",
  REGISTER: "/register",
  FORGET_PASSWORD: "/forget-password",
  CHANGE_PASSWORD: "/change-password",
  USER_ACTIVATION: "/sub-merchant-activation",
  LEADS_REGISTER: "/register/leads/:token"
};

export const outerLayoutRoutes = [
  { name: "login", path: OUTER_ROUTES.LOGIN, element: <Login /> },
  { name: "register", path: OUTER_ROUTES.REGISTER, element: <Register /> },
  { name: "leads_register", path: OUTER_ROUTES.LEADS_REGISTER, element: <Register /> },
  { name: "forget_password", path: OUTER_ROUTES.FORGET_PASSWORD, element: <ForgetPassword /> },
  { name: "sub_merchant_activation", path: OUTER_ROUTES.USER_ACTIVATION, element: <UserActivation /> },
  { name: "change_password", path: OUTER_ROUTES.CHANGE_PASSWORD, element: <ChangePassword /> },
];